import useMonolithApiMutation, { UseMonolithApiMutationOptions } from '@/hooks/api/useMonolithApiMutation';

type Request = { ciConfigExpertSettings: 'disabled' | { wfeIntegration: boolean }; source?: string };

export const workspacesProjectsUpdateCIConfigExpertAIConfigPath = ({
  workspaceSlug,
  projectId,
}: {
  workspaceSlug: string;
  projectId: string;
}) => `/workspaces/${workspaceSlug}/projects/${projectId}/ci_config_expert_ai_config`;

const useWorkspacesProjectsUpdateCIConfigExpertAIConfig = (
  params: { workspaceSlug: string; projectId: string },
  opts?: UseMonolithApiMutationOptions<void, unknown, Request>,
) =>
  useMonolithApiMutation<void, unknown, Request>(
    workspacesProjectsUpdateCIConfigExpertAIConfigPath(params),
    'PATCH',
    opts,
  );

export default useWorkspacesProjectsUpdateCIConfigExpertAIConfig;
